import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

import { Id } from '@feature/utils';

import { getGovStudyDomainsOptions } from './../../model/GovEvaluationQuery';

type GovDomainSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
> & {
  evaluationId: Id;
};

export function GovDomainSelectControl<T extends FieldValues>({
  evaluationId,
  ...props
}: GovDomainSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(getGovStudyDomainsOptions(evaluationId));

  const options = (data ?? []).map(({ id, name, code }) => ({ id, name: `${code} - ${name}` }));

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
